import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UserInterests } from '@zero/depot/domain';
import { environment } from 'environments/environment';
import { map } from 'rxjs';
import { DirectDebitResponse } from '../entities/direct-debit.entity';

@Injectable({ providedIn: 'root' })
export class SepaInfrastructure {
  readonly #api = `${environment.apihost}/api`;
  readonly #http = inject(HttpClient);

  public getSepa = () =>
    this.#http
      .get<UserInterests>(`${this.#api}/usersettings/interests`)
      .pipe(map(({ savingplan_direct_debit_active }) => savingplan_direct_debit_active));

  public toggleSepa = (useDirectDebit: boolean) =>
    this.#http.post<DirectDebitResponse>(`${this.#api}/savingsplan/directdebit`, { useDirectDebit });
}
